import { act } from '@testing-library/react';
import mocks from './mocks';
import { WildcardMockLink } from 'wildcard-mock-link';
export const ApolloMockLink = new WildcardMockLink(mocks, { addTypename: true, act });
